<template>
    <div>
        <form>
            <div class="flex justify-between items-center text-teal hover:text-teal-dark font-base text-s">
                <div class="flex cursor-pointer"></div>
                <button @click.prevent="storeRequiredFields()" type="button" class="py-2 px-3 border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none">
                    Save
                </button>
            </div>
            <div class="flex justify-between items-start mb-4 flex-wrap flex-lg-nowrap">
                <div class="flex-col w-full lg:w-1/2">
                    <div class="rounded bg-white shadow-md mb-4">
                        <div>
                            <i class="fa fa-spin fa-2x fa-spinner text-dark company-required-field-form-loader" v-if="loader" aria-hidden="true"></i>
                        </div>
                        <div class="border-b-2 border-followup-nav py-2 px-3 bg-primary text-white">
                            <span>Company</span>
                        </div>
                        <div class="pt-4 pb-2 px-3" :class="loader ? 'loader-background-form' : ''">
                            <div class="col-12 leading-tight">
                                <input type="checkbox" id="name" name="name" v-model="form.name" disabled>
                                <label class="text-grey-darkest text-md" for="name">Company Name</label>
                            </div>
                            <div class="col-12 leading-tight">
                                <input type="checkbox" id="address" name="address" v-model="form.address">
                                <label class="text-grey-darkest text-md" for="address">Address</label>
                            </div>
                            <div class="col-12 leading-tight">
                                <input type="checkbox" id="city" name="city" v-model="form.city">
                                <label class="text-grey-darkest text-md" for="city">City</label>
                            </div>
                            <div class="col-12 leading-tight">
                                <input type="checkbox" id="state" name="state" v-model="form.state">
                                <label class="text-grey-darkest text-md" for="state">State</label>
                            </div>
                            <div class="col-12 leading-tight">
                                <input type="checkbox" id="zip" name="zip" v-model="form.zip">
                                <label class="text-grey-darkest text-md" for="zip">Zip</label>
                            </div>
                            <div class="col-12 leading-tight">
                                <input type="checkbox" id="phone" name="phone" v-model="form.phone">
                                <label class="text-grey-darkest text-md" for="phone">Phone</label>
                            </div>
                            <div class="col-12 leading-tight">
                                <input type="checkbox" id="fax" name="fax" v-model="form.fax">
                                <label class="text-grey-darkest text-md" for="fax">Fax</label>
                            </div>
                            <div class="col-12 leading-tight">
                                <input type="checkbox" id="website" name="website" v-model="form.website">
                                <label class="text-grey-darkest text-md" for="website">Website</label>
                            </div>
                            <div class="col-12 leading-tight">
                                <input type="checkbox" id="type" name="type" v-model="form.type">
                                <label class="text-grey-darkest text-md" for="type">Company Type</label>
                            </div>
                            <div class="col-12 leading-tight">
                                <input type="checkbox" id="status" name="status" v-model="form.status">
                                <label class="text-grey-darkest text-md" for="status">Status</label>
                            </div>
                            <div v-for="field in teamCustomFields" :key="field.id" class="col-12 leading-tight">
                                <input type="checkbox" id="status" name="status" @click="pushRequiredCustomFields($event, field)" :checked="form.customFields.includes(field.id)">
                                <label class="text-grey-darkest text-md" for="status">{{ field.name }}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import Form from "../../../utils/form";
import axios from "axios";

export default {
    name: 'company-required-fields-form',
    data() {
        return {
            form: {
                name: true,
                address: false,
                city: false,
                state: false,
                zip: false,
                phone: false,
                fax: false,
                website: false,
                type: false,
                status: false,
                customFields: []
            },
            teamCustomFields: [],
            loader: false,
        }
    },
    async mounted() {
        this.loader = true;
        await this.getTeamCustomFields();
        await this.getRequiredFields();
    },
    methods: {
        async getTeamCustomFields() {
            let self = this;
            await axios.get(route('api.company-custom-field.index') + '?company=true').then(({data}) => {
                self.teamCustomFields = data.data;
            });
        },
        pushRequiredCustomFields(event, field) {
            let self = this;
            if(event.target.checked) {
                self.form.customFields.push(field.id);
            }
            else {
                let index = self.form.customFields.indexOf(field.id);
                if (index !== -1) {
                    self.form.customFields.splice(index, 1);
                }
            }
        },
        storeRequiredFields() {
            let self = this;
            axios.post(route('settings.company.required-fields'), self.form).then(({data}) => {
                self.getToast().fire({
                    type: 'success',
                    title: 'Required fields saved successfully.'
                });
            });
        },
        async getRequiredFields() {
            let self = this;
            await axios.get(route('settings.company.required-fields')).then(({data}) => {
                self.form = Object.assign(self.form, data.company_fields);
                this.loader = false;
            }).catch(() => {
                this.loader = false;
            });
        }
    }
}
</script>

<style scoped>
.company-required-field-form-loader {
    position: absolute;
    top: 50%;
    left: 25%;
}
.loader-background-form {
    opacity: 0.2
}
</style>
